import React from 'react';
import AclContext from "./AclContext";
import Slot from "../Slot";
var Case = Slot();
var Default = Slot();
var AclSwitch = function AclSwitch(_ref) {
  var children = _ref.children;
  var acl = React.useContext(AclContext);
  var cases = Case.props(children, true);
  var _default = Default.get(children, false, null);
  var _case = cases.find(function (_case) {
    return acl.isAllow(_case.sujet, _case.action);
  });
  return _case != null && _case.children ? _case.children : _default;
};
AclSwitch.Case = Case;
AclSwitch.Default = Default;
export default AclSwitch;